import { type LucideIcon } from 'lucide-react';
import { Button } from '@avanta/shared/components/ui/Button';
import { CHAT_BUTTON_INPUT_CLASSNAME } from '@avanta/shared/constants/chat';
import { cn } from '@avanta/shared/utils/cn';

interface ToolbarButtonProps {
  label: string;
  icon: LucideIcon;
  active: boolean;
  onClick: () => void;
}

export const ToolbarButton = ({
  label,
  icon: Icon,
  active,
  onClick,
}: ToolbarButtonProps): React.ReactElement => (
  <Button
    key={label}
    type="button"
    variant="ghost"
    icon="only"
    aria-label={label}
    aria-pressed={active}
    className={cn(
      `${CHAT_BUTTON_INPUT_CLASSNAME} hover:[&>svg]:stroke-3`,
      active && `[&>svg]:stroke-3`
    )}
    onClick={onClick}
  >
    <Icon className="size-4" />
  </Button>
);
